import script from "./RealizarPosvenda.vue?vue&type=script&setup=true&lang=js"
export * from "./RealizarPosvenda.vue?vue&type=script&setup=true&lang=js"

import "./RealizarPosvenda.vue?vue&type=style&index=0&id=666faa58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-666faa58"]])

export default __exports__